import "bootstrap/dist/css/bootstrap.css"
import { createApp } from 'vue'
import VOtpInput from 'vue3-otp-input'
import App from "@/App"
import router from "@/router/router"

import "bootstrap/dist/js/bootstrap"
import '@/style/global.scss'

import {vuetifyConfig} from "@/plugins/vuetify";

const app = createApp(App)

app
    .component('v-otp-input', VOtpInput)
    .use(vuetifyConfig)
    .use(router)
    .mount('#app')
